import { BookService } from 'src/app/api/book.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-stop',
  templateUrl: './stop.component.html',
  styleUrls: ['./stop.component.scss']
})
export class StopComponent  {

  constructor(private snackBar: MatSnackBar, private BookService: BookService,
    public dialogRef: MatDialogRef<StopComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }


    IsLoad: boolean = false;


  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.IsLoad = true

    this.BookService.remoteStop(this.data.book.id).subscribe(
      data => {
      console.log(data)
      this.IsLoad = false
      this.openSnackBarDone(data.data.message)
      this.dialogRef.close(true);

      },
      err => {
        console.log(err)
        this.IsLoad = false
        this.openSnackBarError(err.message)
      });
    
   
  }




  openSnackBarDone(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 20000,
    });
  }


  openSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 20000,
    });
  }




}
